// const list1 = [{
//     id: 1,
//     className: 'flex-1',
//     name: '体检',
//     label: 2398
// }, {
//     id: 2,
//     className: 'flex-1',
//     name: '降血脂',
//     label: 3784
// }, {
//     id: 3,
//     className: 'flex-1',
//     name: '降血糖',
//     label: 98341
// }];
const list3 = [{
    id: 1,
    className: 'flex-1',
    name: '外泌体雾化',
    label: 3600,
    tag: ''
}, {
    id: 2,
    className: 'flex-1',
    name: '全基因测序',
    label: 5999,
    tag: ''
}, {
    id: 3,
    className: 'flex-1',
    name: '外泌体回输',
    label: 7999,
    tag: ''
}];

const list3FoShan = [{
    id: 6,
    className: 'flex-1',
    name: '华大壹号',
    label: 7999,
    tag: ''
}];

const listGuoShou = [{
    id: 5,
    className: 'flex-1',
    name: '基因溯源',
    label: 5999,
    tag: ''
}, {
    id: 6,
    className: 'flex-1',
    name: '华大壹号',
    label: 7999,
    tag: ''
}];
const listSuZhou = [{
    id: 8,
    className: 'flex-1',
    name: '细胞存储',
    label: 9999,
    tag: ''
}];
const listChangSha = [{
    id: 8,
    className: 'flex-1',
    name: '细胞存储',
    label: 12000,
    tag: ''
}];
const listGuoShouZhuZhou = [{
    id: 5,
    className: 'flex-1',
    name: '基因溯源',
    label: 8999,
    tag: ''
}, {
    id: 6,
    className: 'flex-1',
    name: '华大壹号',
    label: 12999,
    tag: ''
}, {
    id: 7,
    className: 'flex-1',
    name: '外泌体雾化6支',
    label: 4580,
    tag: ''
}, {
    id: 8,
    className: 'flex-1',
    name: '细胞存储',
    label: 16999,
    tag: ''
}];
const zhengzhou = [{
    id: 1,
    className: 'flex-1',
    name: '外泌体雾化',
    label: 3800,
    tag: ''
}, {
    id: 2,
    className: 'flex-1',
    name: '全基因测序',
    label: 5999,
    tag: ''
}, {
    id: 3,
    className: 'flex-1',
    name: '外泌体回输',
    label: 7999,
    tag: ''
}];
// 1113
const list1 = [{
    id: 4,
    className: 'flex-1',
    name: '定制化免疫细胞存储',
    label: 12000,
    tag: ''
}];
// 1148 1164
const nantong = [{
    id: 4,
    className: 'flex-1',
    name: '定制化免疫细胞存储',
    label: 9999,
    tag: ''
}];
// const list2 = [{
//     id: 7,
//     className: 'flex-1',
//     name: '降血压',
//     label: 3948
// }, {
//     id: 8,
//     className: 'flex-1',
//     name: '消化系统',
//     label: 98341
// }, {
//     id: 9,
//     className: 'flex-1',
//     name: '心脏彩超',
//     label: 3948
// }];
export const list = [list3];
export const expendList = [...list3];
export const guoShouList = [listGuoShou];
export const expendGuoShouList = [...listGuoShou];
export const guoShouZhuZhouList = [listGuoShouZhuZhou];
export const expendGuoShouZhuZhouList = [...listGuoShouZhuZhou];
export const foShanList = [list3FoShan];
export const expendFoShanList = [...list3FoShan];
export const suZhouList = [listSuZhou];
export const expendSuZhouList = [...listSuZhou];

export const changShaList = [listChangSha];
export const expendChangShaList = [...listChangSha];


export const nanTongList = [nantong];
export const expendNanTongList = [...nantong];


export const list2 = [list1];
export const expendList2= [...list1];


export const listzhengzhou = [zhengzhou];
export const expendListzhengzhou= [...zhengzhou];
export const keyNo1113List = [...list1, {
    id: 2,
    className: 'flex-1',
    name: '全基因测序',
    label: 8000,
    tag: ''
}];

export const item = JSON.parse(JSON.stringify({
    personName: "", // 客户姓名
    personIdCard: "", // 客户身份证号
    personPhone: "", // 客户手机号
    checkStartTime: "", // 开始时间
    productList: [], // 产品列表
    sum: 0, // 总计
  }));